import { transactionsPerson } from 'integration/generated/transactions';
import { useNextRouter } from '@/data/Content/_NextRouter';
import { useExtraRequestParameters } from '@/data/Content/_ExtraRequestParameters';
import { useSettings } from '@/data/Settings';
import { getClientSideCommon } from '@/data/utils/getClientSideCommon';
import { useCallback } from 'react';
import { usePersonInfo } from '@/data/Content/PersonInfo';
import getValueByPathFromUnknown from 'integration/utils/getValueByPathFromUnknown';
import valueIsArrayOfAssertion from 'integration/utils/typeAssertions/valueIsArrayOfAssertion';
import valueIsShapeAssertion from 'integration/utils/typeAssertions/valueIsShapeAssertion';
import valueIsString from 'integration/utils/typeAssertions/valueIsString';

type GenericQueryParams = Record<string, any>;

const personUpdateSubscribeToSegmentFetcher =
	(pub: boolean) =>
	async (
		storeId: string,
		data: GenericQueryParams,
		query: GenericQueryParams = {},
		params: GenericQueryParams
	) => {
		const res = await transactionsPerson(pub).personUpdateSubscribeToSegment(
			storeId,
			data,
			query,
			params
		);
		return res;
	};

const valueIsContextAttribute = valueIsArrayOfAssertion(
	valueIsShapeAssertion({
		attributeValue: valueIsArrayOfAssertion(
			valueIsShapeAssertion({
				storeId: valueIsString,
				value: valueIsArrayOfAssertion(valueIsString),
			})
		),
		attributeName: valueIsString,
	})
);

export const useAutoSubscribeToSegment = () => {
	const router = useNextRouter();
	const params = useExtraRequestParameters();
	const { settings: rootSettings } = useSettings();
	const { storeId } = getClientSideCommon(rootSettings, router);
	const { isLoading: isLoadingPersonInfo, mutatePersonInfo } = usePersonInfo();

	const subscribeToSegment = useCallback(async () => {
		const personInfo = await mutatePersonInfo();

		const contextAttribute = getValueByPathFromUnknown(personInfo, ['contextAttribute']);

		if (!valueIsContextAttribute(contextAttribute)) {
			return;
		}

		const offRecommendationAttr = contextAttribute.find(
			(item) => item.attributeName === 'OffRecommendation'
		);

		const offRecommendationAttrValue = offRecommendationAttr?.attributeValue.at(0)?.value.at(0);

		if (offRecommendationAttrValue === '1') {
			await personUpdateSubscribeToSegmentFetcher(true)(storeId, {}, {}, params);
		}
	}, [storeId, params, mutatePersonInfo]);

	return { subscribeToSegment, isLoadingPersonInfo };
};
